export class OverrideStatusEnum
{
  static Untouched = "1";
  static Edited = "2";
  static Modified = "3";
}
